import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";
import { createMockProduct, createProductsAndExchangeToProductsFn, createReturnReasonConfigBottom, createReturnReasonConfigTop } from "../mockCore";

const productData1 = {
    product: createMockProduct({
        id: 1,
        productName: "Ellie Polo Sweatshirt",
        imageSrc: "/mocks/Maya-sweatshirt-black.webp",
        imageAlt: "/mocks/Maya-sweatshirt-black.webp",
        quantity: 1,
        purchasePrice: 699,
        properties: [
            {
                type: "Size",
                value: "S",
            },
            {
                type: "Color",
                value: "Black",
            },
        ],
        returnReasonConfig: createReturnReasonConfigTop(),
    }),
    exchangeToProductsData: {
        originalProductVariants: [
            {
                imageSrc: "/mocks/Maya-sweatshirt-grey.webp",
                properties: [
                    {
                        type: "Color",
                        value: "Gray",
                    },
                    {
                        type: "Size",
                        value: "XS",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Maya-sweatshirt-navy.webp",
                properties: [
                    {
                        type: "Color",
                        value: "Navy",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
        ],
    },
};

const productData2 = {
    product: createMockProduct({
        id: 2,
        productName: "Adrienne Performance",
        imageSrc: "/mocks/Maya-byxa-beige.webp",
        imageAlt: "/mocks/Maya-byxa-beige.webp",
        quantity: 1,
        purchasePrice: 1299,
        properties: [
            {
                type: "Size",
                value: "S",
            },
            {
                type: "Color",
                value: "Beige",
            },
        ],
        returnReasonConfig: createReturnReasonConfigBottom(),
    }),
    exchangeToProductsData: {
        originalProductVariants: [
            {
                properties: [
                    {
                        type: "Color",
                        value: "Beige",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Maya-byxa-brun.webp",
                inventoryMerchant: 1,
                properties: [
                    {
                        type: "Color",
                        value: "Brown",
                    },
                    {
                        type: "Size",
                        value: "S",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Maya-byxa-brun.webp",
                inventoryMerchant: 1,
                properties: [
                    {
                        type: "Color",
                        value: "Brown",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Maya-byxa-red.webp",
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Maya-byxa-red.webp",
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
            {
                imageSrc: "/mocks/Maya-byxa-red.webp",
                inventoryMerchant: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                    },
                    {
                        type: "Size",
                        value: "XL",
                    },
                ],
            },
            {
                properties: [
                    {
                        type: "Color",
                        value: "Beige",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
            {
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Beige",
                    },
                    {
                        type: "Size",
                        value: "XL",
                    },
                ],
            },
        ],
    },
};

const productData3 = {
    product: createMockProduct({
        id: 3,
        productVariantId: 30,
        sessionItemId: 3,
        productName: "Nikita Sport T-Shirt",
        imageSrc: "/mocks/Maya-tshirt.webp",
        imageAlt: "/mocks/Maya-tshirt.webp",
        quantity: 1,
        purchasePrice: 399,
        properties: [
            {
                type: "Size",
                value: "S",
            },
            {
                type: "Color",
                value: "Black",
            },
        ],
        returnReasonConfig: createReturnReasonConfigTop(),
    }),
    exchangeToProductsData: {
        originalProductVariants: [
            {
                inventoryTurnr: 0,
                properties: [
                    {
                        type: "Size",
                        value: "XS",
                    },
                    {
                        type: "Color",
                        value: "Black",
                    },
                ],
            },
            {
                properties: [
                    {
                        type: "Size",
                        value: "M",
                    },
                    {
                        type: "Color",
                        value: "Black",
                    },
                ],
            },
            {
                inventoryMerchant: 0,
                properties: [
                    {
                        type: "Size",
                        value: "L",
                    },
                    {
                        type: "Color",
                        value: "Black",
                    },
                ],
            },
            {
                properties: [
                    {
                        type: "Size",
                        value: "XL",
                    },
                    {
                        type: "Color",
                        value: "Black",
                    },
                ],
            },
        ],
    },
};

const productsAndExchangeToProductsFn = createProductsAndExchangeToProductsFn([productData1, productData2, productData3]);

export function getExchangeToProducts({ productId }) {
    return productsAndExchangeToProductsFn.exchangeToProductsFn({ productId });
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        shipmentSolutions: [
            {
                carrier: "DOORIS",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 0,
            },
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
        ],
        pickupDateSelectionAllowed: true,
        paidShipping: 40,
        turnrShippingCost: 59,
        currencyCode: "SEK",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: productsAndExchangeToProductsFn.products,
    };
}

export function getExchange({ productId }) {
    if (productId === "1") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Maya-sweatshirt-black.webp",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Maya-sweatshirt-black.webp",
                    originalVariant: true,
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Maya-sweatshirt-black.webp",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Maya-sweatshirt-grey.webp",
                    inventoryMerchant: 2,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Grey",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Maya-sweatshirt-grey.webp",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Grey",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Maya-sweatshirt-grey.webp",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Grey",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "7",
                    imageUrl: "/mocks/Maya-sweatshirt-navy.webp",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Navy",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "8",
                    imageUrl: "/mocks/Maya-sweatshirt-navy.webp",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Navy",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "9",
                    imageUrl: "/mocks/Maya-sweatshirt-navy.webp",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Navy",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "2") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Maya-byxa-beige.webp",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Beige",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Maya-byxa-beige.webp",
                    originalVariant: true,
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Beige",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Maya-byxa-beige.webp",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Beige",
                        },
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Maya-byxa-red.webp",
                    inventoryMerchant: 2,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Burgundy",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Maya-byxa-red.webp",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Burgundy",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Maya-byxa-red.webp",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Burgundy",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "3") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "2",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    inventoryMerchant: 0,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
                {
                    id: "4",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 0,
                    properties: [
                        {
                            type: "Size",
                            value: "XL",
                        },
                    ],
                },
            ],
        };
    }

    return {
        exchangeAlternatives: [
            {
                id: "1",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 2,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "2",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 2,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
            {
                id: "3",
                inventoryMerchant: 0,
                inventoryTurnr: 1,
                inventoryTotal: 1,
                properties: [
                    {
                        type: "Color",
                        value: "White",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "4",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 0,
                properties: [
                    {
                        type: "Color",
                        value: "White",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "4",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Green",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
        ],
    };
}
